// src/services/firestoreMonitor.js
// Monitor de lecturas Firestore - solo activo en desarrollo
// Muestra en consola cuántas lecturas se hacen por colección y alerta si se exceden umbrales

const IS_DEV = process.env.NODE_ENV === 'development';

const stats = {
  reads: {},       // { collectionName: count }
  snapshots: {},   // { collectionName: count }
  startTime: Date.now(),
  totalReads: 0,
};

// Umbrales de alerta por colección (lecturas por sesión)
const THRESHOLDS = {
  DEFAULT: 500,
  items: 200,
  notifications: 100,
  schedules: 100,
  users: 50,
  snippets: 50,
};

const getCollectionName = (ref) => {
  if (!ref) return 'unknown';
  // Extract collection name from path or ref
  const path = ref._path?.segments || ref.path?.split('/') || [];
  // For collectionGroup, use the last segment
  return path[path.length - 1] || ref.id || 'unknown';
};

/**
 * Registra una lectura de Firestore
 * @param {string} collection - Nombre de la colección
 * @param {number} docCount - Número de documentos leídos
 * @param {string} type - 'snapshot' | 'getDocs' | 'getDoc'
 */
export const trackRead = (collectionName, docCount = 1, type = 'snapshot') => {
  if (!IS_DEV) return;

  stats.reads[collectionName] = (stats.reads[collectionName] || 0) + docCount;
  stats.snapshots[collectionName] = (stats.snapshots[collectionName] || 0) + 1;
  stats.totalReads += docCount;

  const threshold = THRESHOLDS[collectionName] || THRESHOLDS.DEFAULT;
  if (stats.reads[collectionName] > threshold) {
    console.warn(
      `⚠️ [Firestore Monitor] ${collectionName}: ${stats.reads[collectionName]} lecturas (umbral: ${threshold}) - tipo: ${type}`
    );
  }
};

/**
 * Imprime resumen de lecturas en consola
 */
export const printStats = () => {
  if (!IS_DEV) return;

  const elapsed = Math.round((Date.now() - stats.startTime) / 1000);
  const entries = Object.entries(stats.reads).sort((a, b) => b[1] - a[1]);

  console.group(`📊 [Firestore Monitor] Resumen - ${elapsed}s de sesión`);
  console.log(`Total lecturas: ${stats.totalReads}`);
  console.log(`Lecturas estimadas/día (extrapolado): ${Math.round(stats.totalReads / elapsed * 86400)}`);
  console.table(
    entries.reduce((acc, [col, reads]) => {
      acc[col] = {
        lecturas: reads,
        snapshots: stats.snapshots[col] || 0,
        'docs/snapshot': Math.round(reads / (stats.snapshots[col] || 1)),
      };
      return acc;
    }, {})
  );
  console.groupEnd();
};

/**
 * Resetea los contadores
 */
export const resetStats = () => {
  Object.keys(stats.reads).forEach(k => delete stats.reads[k]);
  Object.keys(stats.snapshots).forEach(k => delete stats.snapshots[k]);
  stats.totalReads = 0;
  stats.startTime = Date.now();
};

// Auto-print cada 60 segundos en desarrollo
if (IS_DEV) {
  setInterval(printStats, 60000);
  // Exponer en window para debug manual: firestoreMonitor.printStats()
  if (typeof window !== 'undefined') {
    window.firestoreMonitor = { printStats, resetStats, stats };
  }
}

export default { trackRead, printStats, resetStats, stats };
